import { render, staticRenderFns } from "./animations-layout.vue?vue&type=template&id=554a65ab&"
import script from "./animations-layout.vue?vue&type=script&lang=js&"
export * from "./animations-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports